// Report failures without Axios request bodies, headers, URLs, tokens, or user data.
export const reportError = (context, error) => {
  const status = error?.response?.status;
  console.error(context, { status: Number.isInteger(status) ? status : "unavailable" });
};
